import styled from 'styled-components';
import { Paper, Container } from '@material-ui/core';

export const ContainerSignIn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  height: 100vh;
  width: 100vw;
  padding: 0;
  margin: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  
  /* Efeito de partículas */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }
`;
export const Card = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
`;

export const TitleSignIn = styled.div`
  text-align: center;
  padding: 15px 0 5px;
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const ContainerButtons = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(102, 126, 234, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  flex-direction: column;
`;

export const StyledPaper = styled(Paper)`
  && {
    width: 100%;
    max-width: 450px;
    min-height: 420px;
    position: relative;
    overflow: hidden;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    background: #ffffff;
    border: none;
    
    /* Efeito de vidro para aparência moderna */
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.95);
    
    @media (max-width: 480px) {
      max-width: 100%;
      min-height: 400px;
      margin: 0 15px;
      border-radius: 12px;
    }
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0 20px;
  
  img {
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const InputContainer = styled.div`
  margin-bottom: 22px;
  
  .MuiTextField-root {
    background: #f8f9fa;
    border-radius: 10px;
    
    .MuiOutlinedInput-root {
      border-radius: 10px;
      font-size: 15px;
      
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: #6A0DAD;
        border-width: 2px;
      }
      
      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #6A0DAD;
        border-width: 2px;
      }
    }
    
    .MuiInputLabel-root {
      color: #5a5a5a;
      font-size: 14px;
      
      &.Mui-focused {
        color: #6A0DAD;
        font-weight: 500;
      }
    }
    
    .MuiInputBase-input {
      color: #2c3e50;
    }
  }
`;

export const ErrorText = styled.div`
  color: #e74c3c;
  font-size: 13px;
  margin-top: 6px;
  min-height: 20px;
  padding-left: 5px;
  font-weight: 500;
`;

export const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  text-align: center;
`;

export const LoadingText = styled.div`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const SubText = styled.div`
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  max-width: 300px;
  line-height: 1.5;
`;

export const FooterText = styled.div`
  text-align: center;
  margin-top: 25px;
  color: #7f8c8d;
  font-size: 12px;
  padding: 0 25px 25px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 10% 20%, rgba(102, 126, 234, 0.1) 0%, transparent 40%),
    radial-gradient(circle at 90% 80%, rgba(118, 75, 162, 0.1) 0%, transparent 40%),
    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 60%);
  pointer-events: none;
  z-index: -1;
 `;